<template>
  <div v-if="poorInfo.length>0" class="poor-tag" @click="showPoorInfo">
    <i class="poor-tag-icon"></i>
    <span class="poor-tag-text">扶贫</span>
  </div>
</template>

<script>
  import _ from 'lodash';

  export default {
    data() {
      return {
        poorInfo: []
      }
    },
    methods: {
      async loadPoorInfo() {
        const resultData = JSON.parse(localStorage.getItem('resultData'));
        const { CorpID, ProductBatchID } = resultData || {};
        if (CorpID && ProductBatchID) {
          const result = await this.$ajax.jsonp(this.$urlAPI.BaseData.GetPoorInfo, { CorpID, ProductBatchID });
          const poorInfo = _.get(result, 'Data.PoorList');
          if (Array.isArray(poorInfo)) {
            this.poorInfo = poorInfo;
          }
        }
      },
      showPoorInfo() {
        this.$router.push({ path: '/poorInfo' });
      }
    },
    mounted() {
      this.loadPoorInfo();
    }
  }
</script>

<style lang="less" scoped>
  @fz: 75;
  .poor-tag {
    position: absolute;
    left: 100%;
    top: 50%;
    display: block;
    white-space: nowrap;
    width: 72px;
    height: 24px;
    margin-top: -11px;
    margin-left: 8px;
    background-color: #ff9a00;
    border-radius: 12px;
    line-height: 24px;
    font-size: 0;
    .poor-tag-icon {
      display: inline-block;
      vertical-align: top;
      background-image: url("../../assets/images/fp-icon.png");
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: center center;
      width: 13px;
      height: 13px;
      margin-top: 5.5px;
    }
    .poor-tag-text {
      font-size: 16px;
      display: inline-block;
      vertical-align: top;
      line-height: 16px;
      margin-top: 4px;
      margin-left: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// poorTag.vue?2e80b500